var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCWb4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8cde3;\n        stroke: #f5a0c5;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #f5a0c5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.79,31.42v-2.91h-7.84c-.99,0-1.73-.22-2.23-.67-.5-.45-.74-1.06-.74-1.83,0-.2,.04-.4,.11-.6,.07-.2,.18-.42,.33-.64,.15-.22,.3-.44,.45-.65,.16-.21,.35-.46,.58-.77l8.28-11.08c.54-.73,.99-1.26,1.34-1.59,.35-.33,.77-.49,1.26-.49,1.58,0,2.38,.91,2.38,2.72v12.09h.67c.8,0,1.45,.11,1.93,.33s.73,.7,.73,1.44c0,.6-.2,1.04-.59,1.32-.4,.28-.99,.41-1.78,.41h-.95v2.91c0,.8-.18,1.4-.53,1.79-.35,.39-.83,.59-1.42,.59s-1.05-.2-1.41-.6-.54-.99-.54-1.77Zm-6.72-6.41h6.72V15.94l-6.72,9.08Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCWb4);
export default __webpack_public_path__ + "static/media/CWb4.743acf6a532b10e71793f1393dae1dc3.svg";
export { ForwardRef as ReactComponent };